module.exports = __webpack_public_path__ + "img/icon-cxbd.7e37b53d.png";